export default {
  loginRequest(login, password, app) {
    var XHR = new XMLHttpRequest()
    XHR.addEventListener('readystatechange', function () {
      if (XHR.readyState === 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '200') {
          app.$store.dispatch('updateData')
          app.$router.push('/')
        } else {
          return app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000})
        }
      }
    })
    XHR.open('POST', 'https://beta.ravadsoftware.com/calendar/api/login.php', true)
    XHR.withCredentials = true
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    XHR.send("user=" + login + "&pass=" + password)
  },
  registrationRequest(login, email, password, name, key, callback) {
    var XHR = new XMLHttpRequest()
    XHR.addEventListener('readystatechange', function () {
      if (XHR.readyState === 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '200') {
          callback(true, response)
        } else {
          callback(false, response)
        }
      }
    })
    XHR.open('POST', 'https://beta.ravadsoftware.com/calendar/api/registration.php', true)
    XHR.withCredentials = true
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    XHR.send("user=" + login + "&pass=" + password + "&email=" + email + "&name=" + name + "&authkey=" + key)
  },
  logout(callback) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/check.php?type=logout', true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '200') {
          return callback(true, response)
        } else {
          return callback(false, response)
        }
      }
    };
    XHR.send();
  },
  checkLogin(app, callback) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/check.php', true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401' || XHR.response == '') {
          app.$router.push('/login')
          return callback ? callback(false) : ''
        } else {
          return callback ? callback(true) : ''
        }
      }
    };
    XHR.send();
  },
  friendRequest(id, type, item, app) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/friendUpdate.php?id=' + id + '&type=' + type, true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          item.status = type
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
        }
      }
    };
    XHR.send();
  },
  addToFriend(id, app, callback) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/friendrequest.php?id=' + id, true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
          callback(false)
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
          callback(true)
        }
      }
    };
    XHR.send();
  },
  setRead(ids, app) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/setRead.php?ids=' + ids.join(','), true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        }
      }
    };
    XHR.send();
  },
  addTask(data, app) {
    var XHR = new XMLHttpRequest();
    XHR.open("POST", 'https://beta.ravadsoftware.com/calendar/api/addTask.php', true);
    XHR.setRequestHeader("Content-Type", "application/json");
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
          app.$store.dispatch('updateData')
        }
      }
    };
    var dataJson = JSON.stringify(data);
    XHR.send(dataJson);
  },
  editTask(data, app) {
    var XHR = new XMLHttpRequest();
    XHR.open("POST", 'https://beta.ravadsoftware.com/calendar/api/editTask.php', true);
    XHR.setRequestHeader("Content-Type", "application/json");
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
          app.$store.dispatch('updateData')
        }
      }
    };
    var dataJson = JSON.stringify(data);
    XHR.send(dataJson);
  },
  updateTimeEvent(data, app) {
    var XHR = new XMLHttpRequest();
    XHR.open("POST", 'https://beta.ravadsoftware.com/calendar/api/updateTimeEvent.php', true);
    XHR.setRequestHeader("Content-Type", "application/json");
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
          app.$store.dispatch('updateData')
        }
      }
    };
    var dataJson = JSON.stringify(data);
    XHR.send(dataJson);
  },
  setStatus(id, title, app) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/setStatus.php?id='+id+'&status='+title, true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
          app.$store.dispatch('updateData')
        }
      }
    };
    XHR.send();
  },
  sendNotify(data, app) {
    var XHR = new XMLHttpRequest();
    XHR.open("POST", 'https://beta.ravadsoftware.com/calendar/api/sendNotify.php', true);
    XHR.setRequestHeader("Content-Type", "application/json");
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code === '401') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged. Please log in again.', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code !== '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          app.$notify({ group: 'notify', type: 'success', title: 'Success', text: response.info, duration: 3000 })
        }
      }
    };
    var dataJson = JSON.stringify(data);
    XHR.send(dataJson);
  },
  getRecentNotify(callback, app) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/recentNotify.php', true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code == '401' || XHR.response == '') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged in', duration: 3000 })
          app.$router.push('/login')
        } else if (response.code != '200') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: response.info, duration: 3000 })
        } else {
          callback(response)
        }
      }
    };
    XHR.send();
  },
  searchFriends(search, app, callback) {
    var XHR = new XMLHttpRequest()
    XHR.open('GET', 'https://beta.ravadsoftware.com/calendar/api/searchFriend.php?search=' + search, true);
    XHR.withCredentials = true;
    XHR.onreadystatechange = function () {
      if (XHR.readyState == 4) {
        var response = JSON.parse(XHR.response)
        if (response.code == '401' || XHR.response == '') {
          app.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Not logged in', duration: 3000 })
          app.$router.push('/login')
        } else {
          callback(true, response)
        }
      }
    };
    XHR.send();
  }
}